export class PlatformDescriptor {
    public static iOS = new PlatformDescriptor('iOS', true);
    public static web = new PlatformDescriptor('web', false);
    public static Desktop = new PlatformDescriptor('desktop', false);
    public static Android = new PlatformDescriptor('Android', true);
    public static emulated = new PlatformDescriptor('emulated', false);
    constructor(public name: string, public useHash: boolean) {}
}
